import request from '@/config/axios'

export interface BossCircleBannerVO {
  id?: number
  title: string
  bannerType: string
  imageUrl: string
  linkUrl?: string
  sort: number
  status: number
  createTime?: string
}

export const getBannerList = () => request.get({ url: '/bosscircle/banner/list' })

export const createBanner = (data: BossCircleBannerVO) =>
  request.post({ url: '/bosscircle/banner/create', data })

export const updateBanner = (data: BossCircleBannerVO) =>
  request.put({ url: '/bosscircle/banner/update', data })

export const deleteBanner = (id: number) =>
  request.delete({ url: '/bosscircle/banner/delete', params: { id } })
